import React from "react";
import { Row, Column } from "@/shared/ui/Blocks";
import { MembersRow } from "@/shared/widgets/MembersRow";

import { Person } from "@/features/people/graphql/generated";
import { Team } from "@/features/teams/graphql/generated";
import { toNumber } from "lodash";
import MarkdownText from "@/shared/widgets/MarkdownText";
import { cleanupMarkdownFromTags } from "@/shared/utils/parsers/cleanupMarkdownFromTags";

export const TeamSummary = ({
  team,
  members,
  summary,
}: {
  team: Team;
  members: Person[];
  summary?: string;
}) => {
  return (
    // Team summary page
    <>
      <Row className="justify-between">
        <Column className="gap-2">
          <h2>{team.name}</h2>
        </Column>
        <Column className="shrink-0">
          <MembersRow
            className="max-w-[550px] justify-end"
            teamId={toNumber(team?.id)}
            members={members as Person[]}
            canAdd={false}
          />
        </Column>
      </Row>
      {!!summary && (
        <Column className="mt-8 gap-4">
          <h3>Summary</h3>
          <MarkdownText text={cleanupMarkdownFromTags(summary || "")} />
        </Column>
      )}
    </>
  );
};
